exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2019\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore .crossHair {\n  width: 100%;\n  height: 100%;\n  display: flex;\n}\n\n.explore .displayBox {\n  width: 100%;\n  height: 100%;\n}\n\n.explore .display_col1 {\n  width: 50%;\n  padding-left: 8px;\n}\n\n.explore .display_col2 {\n  width: 50%;\n  font-weight: 600;\n  padding-right: 8px;\n}\n\n.explore .popover_rows {\n  font-size: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-1!./node_modules/postcss-loader??ref--1-2!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js??ref--1-4!./src/js/components/display-tooltipinfo/DisplayTooltipInfo.scss
// module id = 418
// module chunks = 0